import { TextField } from '@mui/material';

type StreetInputProps = {
  value: string;
  onChange: (value: string) => void;
  required: boolean;
};

export function StreetInput({ value, onChange, required }: StreetInputProps) {
  return (
    <TextField
      type='text'
      label='Straße'
      id='street'
      size='small'
      value={value}
      onChange={event => onChange(event.target.value)}
      fullWidth
      required={required}
    />
  );
}
